module.exports = __webpack_public_path__ + "static/media/lens1_grayzel.32fc09c4.png";